// VC: on a sport page, never recommend items whose name is for a different sport
const VC_SPORT_WORDS = { running: ['running'], basketball: ['basketball'], soccer: ['soccer'], pickleball: ['pickleball'], 'combat-sports': ['combat', 'boxing', 'mma'], tennis: ['tennis'], volleyball: ['volleyball'], 'baseball-softball': ['baseball', 'softball'], football: ['football'], golf: ['golf'], 'training-gym': ['training', 'gym'], yoga: ['yoga'], cycling: ['cycling'] };
function sportOk(prods, sport) {
  if (!sport || !VC_SPORT_WORDS[sport]) return prods;
  const others = Object.entries(VC_SPORT_WORDS).filter(([k]) => k !== sport).flatMap(([, w]) => w);
  return prods.filter((p) => { const t = (p.title || '').toLowerCase(); if (VC_SPORT_WORDS[sport].some((w) => new RegExp('\\b' + w + '\\b').test(t))) return true; return !others.some((w) => new RegExp('\\b' + w + '\\b').test(t)); });
}
/* Vantacore matching-product suggestions for the cart drawer, cart page and product pages. */
const DEALS = {
  leggings: { noun: 'pair of leggings', plural: 'leggings', url: '/collections/leggings', pool: ['leggings', 'leggings-with-pockets'] },
  biker: { noun: 'pair of biker shorts', plural: 'biker shorts', url: '/collections/biker-shorts', pool: ['biker-shorts', 'biker-shorts-with-pockets'] },
  mens: { noun: 'multipurpose shirt or shorts', plural: "men's multipurpose shirts & shorts", url: '/collections/athletic-workout-shirts', pool: ['athletic-workout-shirts', 'athletic-multipurpose-shorts'] },
};
const STOP = new Set(("women's womens women woman men's mens men man unisex kids biker bikers shorts short leggings legging high-waisted high-waist high waisted waist yoga multipurpose athletic athletics shirt shirts tee tees t-shirt tank top tops muscle jersey matching set sets with pockets pocket jogger joggers running run performance long sleeve sports bra bras hoodie hoodies sweatshirt crewneck crew neck aop (aop) & and + the for of a workout gym graphic casual button-up polo cap hat trucker snapback pants pant capri capris moisture wicking embroidered low profile baseball adjustable cotton dad vantacore all-over print printed colorful cycling bold training train everyday essential- lightweight seamless flare bottoms piece 2-piece").split(/\s+/));
const fmt = (c) => '$' + (Number(c) / 100).toFixed(2);
const cache = new Map();
const productCache = new Map();
let EV = null;
import('@shopify/events').then((m) => { EV = m; }).catch(() => {});

function tokens(s) {
  return s.replace(/[()]/g, ' ').split(/\s+/).map((t) => t.trim()).filter(Boolean);
}
function printKey(title) {
  const segs = title.split(/\s[|—–-]\s|\s?\|\s?/).map((s) => s.trim()).filter(Boolean);
  let best = [];
  for (const s of segs) {
    const keep = tokens(s).filter((t) => !STOP.has(t.toLowerCase()) && !/^\d+$/.test(t));
    if (keep.length > best.length) best = keep;
  }
  return best.slice(0, 4);
}
function shortTitle(t) {
  return t.split(/\s[—–]\s/)[0].replace(/\s*\(AOP\)\s*/i, ' ').replace(/\s+/g, ' ').trim();
}
function sizeLabel(p, v) {
  const opts = v.options || [v.title];
  if (opts.length < 2) return v.title;
  const varying = opts.map((_, i) => new Set(p.variants.map((x) => (x.options || [])[i])).size > 1);
  const parts = opts.filter((_, i) => varying[i]);
  return parts.length ? parts.join(' / ') : v.title;
}
function img(u, w) {
  if (!u) return '';
  if (u.startsWith('//')) u = 'https:' + u;
  return u + (u.includes('?') ? '&' : '?') + 'width=' + w;
}
function genderOf(s) {
  s = String(s || '').toLowerCase();
  if (/women|ladies|female/.test(s)) return 'w';
  if (/(^|[^a-z])men('?s)?([^a-z]|$)|(^|-)mens(-|$)|unisex/.test(s)) return /unisex/.test(s) ? null : 'm';
  return null;
}
let GENDER = null;
const okGender = (p) => { if (!GENDER) return true; const g = genderOf(p.title + ' ' + p.handle); return !g || g === GENDER; };
async function getJSON(u) {
  const r = await fetch(u, { headers: { Accept: 'application/json' } });
  if (!r.ok) throw new Error(u + ' ' + r.status);
  return r.json();
}
async function product(handle) {
  if (!productCache.has(handle)) productCache.set(handle, getJSON('/products/' + encodeURIComponent(handle) + '.js').catch(() => null));
  return productCache.get(handle);
}
async function samePrint(title, exclude) {
  let key = printKey(title);
  if (!key.length) return [];
  const run = async (k) => {
    const u = '/search/suggest.json?q=' + encodeURIComponent(k.join(' ')) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
    const d = await getJSON(u).catch(() => null);
    const list = d?.resources?.results?.products || [];
    const kl = k.map((x) => x.toLowerCase());
    return list.filter((p) => !exclude.has(p.handle) && okGender(p) && kl.every((w) => p.title.toLowerCase().includes(w)));
  };
  let res = await run(key);
  if (!res.length && key.length >= 3) {
    const k2 = key.filter((w) => w.toLowerCase() !== 'halloween').slice(0, 2);
    if (k2.length === 2) res = await run(k2);
  }
  return res.map((p) => p.handle);
}
async function related(pid, exclude, n) {
  const d = await getJSON('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related').catch(() => null);
  return (d?.products || []).filter((p) => p.available && !exclude.has(p.handle) && okGender(p)).slice(0, n).map((p) => p.handle);
}
async function dealPool(group, exclude, n) {
  const g = DEALS[group];
  const lists = await Promise.all(g.pool.map((h) => getJSON('/collections/' + h + '/products.json?limit=30').then((d) => d.products || []).catch(() => [])));
  const all = lists.flat().filter((p) => !exclude.has(p.handle) && okGender(p) && p.variants?.some((v) => v.available));
  for (let i = all.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [all[i], all[j]] = [all[j], all[i]]; }
  return all.slice(0, n).map((p) => p.handle);
}

async function build(data) {
  const items = data.items || [];
  const exclude = new Set(items.map((i) => i.handle));
  const picks = [];
  const add = (hs, max) => { for (const h of hs) { if (picks.length >= max) break; if (!picks.includes(h)) { picks.push(h); exclude.add(h); } } };
  let nudge = null;
  GENDER = null;
  for (const i of items) { const g = genderOf(i.title + ' ' + i.handle) || (i.deal === 'mens' ? 'm' : (i.deal ? 'w' : null)); if (g) { GENDER = g; break; } }
  if (data.mode === 'cart') {
    const counts = {};
    for (const i of items) if (i.deal) counts[i.deal] = (counts[i.deal] || 0) + i.qty;
    const g = items.map((i) => i.deal).find((d) => d && counts[d] % 2 === 1);
    if (g) nudge = { group: g, ...DEALS[g] };
    for (const it of items.slice(0, 2)) add(await samePrint(it.title, exclude), 2);
    if (nudge) add(await dealPool(nudge.group, exclude, 2), 4);
    if (picks.length < 4 && items[0]) add(await related(items[0].pid, exclude, 6), 4);
    if (picks.length < 4) add(await dealPool(GENDER === 'm' ? 'mens' : (nudge?.group === 'biker' ? 'leggings' : 'biker'), exclude, 4), 4);
  } else {
    const it = items[0];
    if (it.deal) nudge = { group: it.deal, ...DEALS[it.deal] };
    add(await samePrint(it.title, exclude), 3);
    if (it.deal === 'mens') {
      const wantShorts = !/short/i.test(it.title + it.handle);
      const pool = await dealPool('mens', exclude, 12);
      const pref = pool.filter((h) => /short/i.test(h) === wantShorts);
      add(pref.concat(pool), 4);
    }
    if (picks.length < 4) add(await related(it.pid, exclude, 6), 4);
    if (picks.length < 4 && GENDER !== 'm') {
      const other = it.deal === 'biker' ? 'leggings' : 'biker';
      add(await dealPool(other, exclude, 4), 4);
    }
  }
  const prods = (await Promise.all(picks.map(product))).filter((p) => p && p.available);
  return { nudge, prods };
}

function card(p, mode) {
  const avail = p.variants.filter((v) => v.available);
  const single = p.variants.length === 1;
  const compare = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + fmt(p.compare_at_price) + '</s>' : '';
  const opts = single ? '' : '<select class="vc-recs__size" aria-label="Size for ' + esc(shortTitle(p.title)) + '"><option value="">Size</option>' + avail.map((v) => '<option value="' + v.id + '">' + esc(sizeLabel(p, v)) + '</option>').join('') + '</select>';
  return '<div class="vc-recs__card" data-variant="' + (single ? avail[0]?.id || '' : '') + '">' +
    '<a class="vc-recs__img" href="' + p.url + '"><img loading="lazy" alt="" src="' + img(p.featured_image, 320) + '"></a>' +
    '<a class="vc-recs__name" href="' + p.url + '">' + esc(shortTitle(p.title)) + '</a>' +
    '<div class="vc-recs__price"><b>' + fmt(p.price) + '</b>' + compare + '</div>' +
    '<div class="vc-recs__buy">' + opts + '<button type="button" class="vc-recs__add">Add</button></div>' +
    '</div>';
}
function esc(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

function paint(el, res, data) {
  const body = el.querySelector('[data-vc-recs-body]');
  if (!body) return;
  const mode = data.mode;
  let html = '';
  if (res.nudge) {
    html += mode === 'cart'
      ? '<a class="vc-recs__nudge" href="' + res.nudge.url + '"><b>Add 1 more ' + res.nudge.noun + '</b> and get 40% off the lower-priced one. <span>Shop all &rarr;</span></a>'
      : '<a class="vc-recs__nudge" href="' + res.nudge.url + '"><b>Buy 1, get 1 40% off</b> &mdash; mix &amp; match any ' + res.nudge.plural + '. Applied automatically. <span>Shop all &rarr;</span></a>';
  }
  if (res.prods.length) {
    html += '<p class="vc-recs__title">' + esc(el.dataset.heading || (mode === 'cart' ? 'Complete your look' : 'Complete the look')) + '</p>';
    html += '<div class="vc-recs__row">' + sportOk(res.prods, data.sport).slice(0, 4).map((p) => card(p, mode)).join('') + '</div>';
  }
  body.innerHTML = html;
  body.dataset.done = '1';
  el.hidden = !html;
}

async function render(el) {
  const body = el.querySelector('[data-vc-recs-body]');
  const raw = el.querySelector('[data-vc-recs-data]');
  if (!body || !raw) return;
  let data;
  try { data = JSON.parse(raw.textContent); } catch (e) { return; }
  if (!data.items || !data.items.length) { el.hidden = true; return; }
  const sig = data.mode + '|' + data.items.map((i) => i.handle + ':' + i.qty).join(',');
  if (body.dataset.sig === sig && body.dataset.done) return;
  body.dataset.sig = sig;
  if (!cache.has(sig)) cache.set(sig, build(data).catch(() => ({ nudge: null, prods: [] })));
  const res = await cache.get(sig);
  if (body.dataset.sig === sig) paint(el, res, data);
}

async function addToCart(id, btn) {
  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);
  let deferred = null;
  if (EV?.CartLinesUpdateEvent) {
    deferred = EV.CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(new EV.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: deferred.promise }));
  }
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sectionIds.join(',') }),
  }).then((r) => r.json());
  if (res.status) {
    deferred?.reject?.(new Error(res.description || 'add failed'));
    throw new Error(res.description || res.message || 'Could not add');
  }
  const cart = await getJSON('/cart.js');
  if (deferred) {
    deferred.resolve({
      cart: EV.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'vc-recs', sourceId: 'vc-recs', itemCount: 1, productId: '', sections: res.sections, didError: false },
    });
  } else {
    location.href = '/cart';
  }
  document.querySelectorAll('.header-actions__cart-icon [data-cart-count], cart-icon .cart-bubble__text-count').forEach((n) => { n.textContent = cart.item_count; });
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest && e.target.closest('.vc-recs__add');
  if (!btn) return;
  e.preventDefault();
  const c = btn.closest('.vc-recs__card');
  const sel = c.querySelector('.vc-recs__size');
  const id = sel ? sel.value : c.dataset.variant;
  if (!id) { sel?.classList.add('vc-recs__size--need'); sel?.focus(); return; }
  btn.disabled = true; btn.textContent = 'Adding…';
  try { await addToCart(id, btn); btn.textContent = 'Added'; }
  catch (err) { btn.textContent = 'Try again'; }
  setTimeout(() => { btn.disabled = false; btn.textContent = 'Add'; }, 1600);
});
document.addEventListener('change', (e) => { if (e.target.classList?.contains('vc-recs__size')) e.target.classList.remove('vc-recs__size--need'); });

let t = null;
function scan() { document.querySelectorAll('[data-vc-recs]').forEach((el) => render(el)); }
function schedule() { clearTimeout(t); t = setTimeout(scan, 120); }
new MutationObserver((muts) => {
  for (const m of muts) {
    const tg = m.target.nodeType === 1 ? m.target : m.target.parentElement;
    if (tg && tg.closest && tg.closest('[data-vc-recs]')) { schedule(); return; }
    for (const n of m.addedNodes) { if (n.nodeType === 1 && (n.matches?.('[data-vc-recs]') || n.querySelector?.('[data-vc-recs]'))) { schedule(); return; } }
  }
}).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-done', 'data-sig'] });
document.addEventListener('cart:update', schedule);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
